import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

function WebDesignPackages() {
  return (
    <>
      <Helmet>
        <title>Web Design Packages Abu Dhabi, Ajman, Sharjah, Fujairah, Dubai, UAE</title>
        <meta name="description" content={"Looking for a reliable and cost-efficient web design package? We offer flexible web design packages in Dubai tailored to your business goals, budget, and growth strategy."} />
        <meta name="keywords" content={"web design packages uae,web design packages abu dhabi,web design packages sharjah,web design packages ajman,web design packages fujairah,web design packages dubai "} />
        <link rel="canonical" href={"https://www.websiteseo.ae/web-design-packages"} />
        <script type="application/ld+json">
          {JSON.stringify({
  "@context": "https://schema.org",
  "@type": "Organization",
  "name": "Websiteseo",
  "url": "https://www.websiteseo.ae/",
  "logo": {
    "@type": "ImageObject",
    "url": "https://www.websiteseo.ae/images/img/logo.png"
  },
  "description": "WebsiteSEO is a digital solutions agency offering website design and development, SEO, mobile app development, domain registration, web hosting, social media marketing, email marketing, SMS marketing, branding, and online marketing services to help businesses build and strengthen their digital presence.",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Office# 114 Al Ahbabi Building Damascus Street, Al Qusais Dubai, United Arab Emirates",
    "addressLocality": "Dubai",
    "addressRegion": "Dubai",
    "postalCode": "00000",
    "addressCountry": "UAE"
  },
  "contactPoint": [
    {
      "@type": "ContactPoint",
      "telephone": "+971 55 570 9788",
      "contactType": "customer service",
      "email": "sales@websiteseo.ae"
    }
  ]
})}
        </script>
      </Helmet>

<div>
  {/* HEADER
  ============================================= */}
  {/* END HEADER */}
  {/* HERO
  ============================================= */}
  <div className="inner-page-banner-wrap" style={{backgroundImage: 'url(/legacy/images/img/inner-banner-bg.jpg)', backgroundSize: 'cover', backgroundAttachment: 'fixed'}}>
    <div className="container">
      <h3>Web Design Packages</h3>
      <ul>
        <li><Link to="/">Home</Link></li>
        <li>Web Design Packages</li>
      </ul>
    </div>
  </div>
  <section style={{width: '100%', height: 200}}>
    <h1 style={{fontSize: 24, marginTop: 40, marginLeft: 70}}>Web Design Packages Abu Dhabi, Ajman, Sharjah, Fujairah, Dubai, UAE</h1>
  </section>
  {/* FOOTER
  ============================================= */}
  {/* END FOOTER */}
</div>

    </>
  );
}

export default WebDesignPackages;
